import { FC } from 'react';

import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useFulfilmentProvidersSelect from './hooks/useFulfilmentProvidersSelect';

type ShippingProvidersSelectProps = {
  fulfilmentProvidersSelectState: ReturnType<
    typeof useFulfilmentProvidersSelect
  >;
};

const ShippingProvidersSelect: FC<ShippingProvidersSelectProps> = ({
  fulfilmentProvidersSelectState,
}) => {
  const {
    validationError,
    fulfilmentProviders,
    selectedFulfilmentProvider,
    setSelectedFulfilmentProvider,
  } = fulfilmentProvidersSelectState;

  if (!fulfilmentProviders) return null;

  return (
    <FormControl error={!!validationError}>
      <InputLabel id='select-helper-label'>Shipping Provider</InputLabel>
      <Select
        labelId='select-helper-label'
        id='select-helper'
        value={selectedFulfilmentProvider}
        label='Fulfilment Provider'
        onChange={(e) => setSelectedFulfilmentProvider(e.target.value)}
      >
        {fulfilmentProviders?.map(
          ({ fulfilment_provider_id, provider_name }) => (
            <MenuItem
              key={fulfilment_provider_id}
              value={fulfilment_provider_id}
            >
              <Stack spacing={0.5} direction='row' alignItems='center'>
                <Typography variant='body1'>{provider_name}</Typography>
              </Stack>
            </MenuItem>
          ),
        )}
      </Select>
      {!!validationError && <FormHelperText>{validationError}</FormHelperText>}
    </FormControl>
  );
};

export default ShippingProvidersSelect;
